import React from 'react'
import { injectIntl } from 'react-intl'

const InjectedComponent = ({ intl, children }) => <>{React.cloneElement(children, { intl })}</>
export default injectIntl(InjectedComponent)
